module.exports = __webpack_public_path__ + "static/media/VehicleVan.9d4fcf98.png";